import { useState } from 'react';

/**
 * Drawer state shared by the five profiles: one drawer at a time. All the drawers of a profile
 * live in its container, the sendout drawer too.
 * The containers keep no drawer state of their own: they only read these verbs. Drawer names
 * are the constants of each entity meta (CANDIDATE_DRAWERS.Edit, ...), never loose strings.
 * @param {Object} params
 * @param {() => void} params.onChanged Reloads the profile; it is what closeAndRefresh runs
 * @param {(tabId: string) => void} params.onTabChanged Reloads one tab; it is what
 *   closeAndRefreshTab runs
 * @returns {{
 *   drawer: string | null,
 *   drawerItemId: number | string | null,
 *   openDrawer: (name: string) => () => void,
 *   openItemDrawer: (name: string) => (item: { id: number | string }) => void,
 *   closeDrawer: () => void,
 *   closeAndRefresh: () => void,
 *   closeAndRefreshTab: (tabId: string) => () => void
 * }}
 */
export const useProfileDrawer = ({ onChanged, onTabChanged }) => {
  const [drawer, setDrawer] = useState(null);
  const [drawerItemId, setDrawerItemId] = useState(null);

  const openDrawer = name => () => {
    setDrawer(name);
    setDrawerItemId(null);
  };
  const openItemDrawer = name => item => {
    setDrawer(name);
    setDrawerItemId(item.id);
  };
  const closeDrawer = () => setDrawer(null);
  const closeAndRefresh = () => {
    onChanged && onChanged();
    closeDrawer();
  };
  const closeAndRefreshTab = tabId => () => {
    onTabChanged(tabId);
    closeDrawer();
  };

  return {
    closeAndRefresh,
    closeAndRefreshTab,
    closeDrawer,
    drawer,
    drawerItemId,
    openDrawer,
    openItemDrawer
  };
};
